// import React, { useEffect, useState } from "react";
// import Table from "../Common/Table/main";
// import SearchBar from "../Common/SearchBar/main";
// import { Dayjs } from "dayjs";
// import { usePayments } from "../../hook/usePayments";
// import { useTenants } from "../../hook/useTenents";
// import { useUsers } from "../../hook/useUsers";
// import { DatePicker, DatePickerProps } from "antd";
// import { Popup } from "../Common/Popup/main";
// import AlertPopup from "../Popups/alertPopup";
// import ExportPopup from "../Popups/exportPopup";
// import toast from "react-hot-toast";
// import SuggestionInput from "../Common/SuggestionInput/main";
// import { RiMoneyRupeeCircleFill } from "react-icons/ri";
// import Dropdown from "../Common/Dropdown/main";
// import { FaUser } from "react-icons/fa";
// import Slider from 'rc-slider';
// import 'rc-slider/assets/index.css';
// import { useProperties } from "../../hook/useProperties";
// import { useApartment } from "../../hook/useApartment";

// interface Payment {
//   id: number;
//   tenantName: string;
//   paymentStatus: string;
//   paymentCollectedOn: string | null;
//   paymentCollectedBy: string | null;
//   rentOf: string;
//   balanceAmount: number;
//   amountReceived: number;
//   paymentMode: string | null;
//   paymentType: string;
// }

// interface ExpenseFilter {
//   apartmentId?: number;
//   propertyId?: number;
//   tenantId?: number;
//   expenseType?: string;
//   amountFrom?: number;
//   amountTo?: number;
//   dateFrom?: string;
//   dateTo?: string;
//   page?: number;
//   size?: number;
// }

// interface PaymentFilter {
//   propertyId?: number,
//   tenantId?: number;
//   paymentStatus?: string;
//   paymentCollectedOnFrom?: string;
//   paymentCollectedOnTo?: string;
//   rentOfFrom?: string;
//   rentOfTo?: string;
//   maxAmountReceived?: number;
//   maxBalanceAmount?: number;
//   paymentMode?: string;
//   paymentType?: string;
//   paymentCollectedById?: number;
// }

// interface PaymentApiParams {
//   propertyId?: number,
//   tenantId?: number;
//   paymentStatus?: string;
//   fromDate?: string;
//   toDate?: string;
//   rentOfFrom?: string;
//   rentOfTo?: string;
//   maxAmountReceived?: number;
//   maxBalanceAmount?: number;
//   paymentMode?: string;
//   paymentType?: string;
//   paymentCollectedById?: number;
//   page?: number;
//   size?: number;
// }

// interface Apartment {
//   id: number;
//   apartmentName: string;
// }

// interface Property {
//   id: number;
//   propertyName: string;
//   apartmentId?: number;
// }

// interface Tenant {
//   id: number;
//   name: string;
//   propertyId?: number;
//   apartmentId?: number;
// }

// const PaymentHistory: React.FC = () => {
//   const [viewType, setViewType] = useState<"payment" | "expense">("payment");
//   const [filters, setFilters] = useState<PaymentFilter>({});
//   const [expenseFilters, setExpenseFilters] = useState<ExpenseFilter>({});

//   const { PaymentHistory: fetchPaymentHistoryMutation } = usePayments();
//   const { 
//     Apartment: useApartments,
//     useGetPropertiesInApartment,
//     useGetTenantsInProperty,
//     useGetTenantsInApartment,
//     filterExpenses
//   } = useApartment();
  
//   const {
//     data: paymentHistoryData,
//     isPending: isPaymentHistoryLoading,
//     isError: isPaymentHistoryError,
//     error: paymentHistoryError,
//     mutate: fetchPaymentHistory,
//   } = fetchPaymentHistoryMutation;
  
//   const [expenseData, setExpenseData] = useState<any>(null);
//   const [isExpenseLoading, setIsExpenseLoading] = useState(false);
//   const [isExpenseError, setIsExpenseError] = useState(false);
  
//   const { _Tenants } = useTenants();
//   const TenantsData = _Tenants() as any;
//   const { Property } = useProperties();
//   const PropertiesData = Property({ active: true, delete: false, page: 0, size: 10000 }) as any;
//   const UsersData = useUsers() as any;
  
//   const [searchQuery, setSearchQuery] = useState("");
//   const [alertPopup, setAlertPopup] = useState<boolean>(false);
//   const [errmessage, setErrMessage] = useState("");
//   const [tenantIdSearch, setTenantIdSearch] = useState<any>();
//   const [userIdSearch, setUserIdSearch] = useState<any>();
//   const [paymentCollectedByName, setPaymentCollectedByName] = useState<string>("");
//   const [isPopupOpen, setIsPopupOpen] = useState(false);
//   const [isFilterPopupOpen, setIsFilterPopupOpen] = useState(false);
//   const [paymentStatusOpen, setPaymentStatusOpen] = useState(false);
//   const [paymentModeOpen, setPaymentModeOpen] = useState(false);
//   const [paymentTypeOpen, setPaymentTypeOpen] = useState(false);
  
//   const [currentPage, setCurrentPage] = useState(0);
//   const [itemsPerPage, setItemsPerPage] = useState(10); 
//   const pageSizeOptions = [10,25, 50, 100];
  
//   const [apartments, setApartments] = useState<Apartment[]>([]);
//   const [properties, setProperties] = useState<Property[]>([]);
//   const [filteredProperties, setFilteredProperties] = useState<Property[]>([]);
//   const [tenants, setTenants] = useState<Tenant[]>([]);
//   const [filteredTenants, setFilteredTenants] = useState<Tenant[]>([]);
//   const [paymentFilteredTenants, setPaymentFilteredTenants] = useState<Tenant[]>([]);
//   const [isLoadingApartments, setIsLoadingApartments] = useState(false);
//   const [isLoadingProperties, setIsLoadingProperties] = useState(false);
//   const [isLoadingTenants, setIsLoadingTenants] = useState(false);

//   // Use the apartment hook to fetch apartments
//   const { data: apartmentsData, isLoading: isApartmentsLoading } = useApartments({ 
//     active: true, 
//     delete: false 
//   });

//   // Call the hooks at the top level (not inside useEffect)
//   const propertiesInApartmentQuery = useGetPropertiesInApartment(expenseFilters.apartmentId || 0);
//   const tenantsInPropertyQuery = useGetTenantsInProperty(filters.propertyId || expenseFilters.propertyId || 0);
//   const tenantsInApartmentQuery = useGetTenantsInApartment(expenseFilters.apartmentId || 0);

//   // Get all properties and tenants for initial display (like payment filters)
//   const getAllProperties = () => {
//     if (PropertiesData.data) {
//       return [
//         ...(PropertiesData.data?.data?.COMMERCIAL || []),
//         ...(PropertiesData.data?.data?.RESIDENTIAL || [])
//       ];
//     }
//     return [];
//   };

//   const getAllTenants = () => {
//     if (TenantsData.data) {
//       return [
//         ...(TenantsData.data?.data?.commercialTenants || []),
//         ...(TenantsData.data?.data?.residentialTenants || [])
//       ];
//     }
//     return [];
//   };

//   // Set apartments data when loaded
//   useEffect(() => {
//     if (apartmentsData?.data?.content) {
//       setApartments(apartmentsData.data.content);
//     }
//   }, [apartmentsData]);

//   // Set properties data when loaded from PropertiesData
//   useEffect(() => {
//     const allProperties = getAllProperties();
//     setProperties(allProperties);
//     setFilteredProperties(allProperties);
//   }, [PropertiesData.data]);

//   // Set tenants data when loaded from TenantsData
//   useEffect(() => {
//     const allTenants = getAllTenants();
//     setTenants(allTenants);
//     setFilteredTenants(allTenants);
//     setPaymentFilteredTenants(allTenants);
//   }, [TenantsData.data]);

//   // Filter properties when apartment is selected
//   useEffect(() => {
//     if (expenseFilters.apartmentId) {
//       setIsLoadingProperties(true);
      
//       if (propertiesInApartmentQuery.data) {
//         setFilteredProperties(propertiesInApartmentQuery.data.data || []);
//         setIsLoadingProperties(false);
//       }
      
//       if (propertiesInApartmentQuery.isError) {
//         console.error('Error fetching properties:', propertiesInApartmentQuery.error);
//         toast.error('Failed to load properties');
//         setIsLoadingProperties(false);
//       }
//     } else {
//       // Show ALL properties when no apartment is selected
//       setFilteredProperties(getAllProperties());
//     }
//   }, [expenseFilters.apartmentId, PropertiesData.data, propertiesInApartmentQuery.data, propertiesInApartmentQuery.isError]);

//   // Filter tenants for payment view when property is selected
//   useEffect(() => {
//     if (filters.propertyId) {
//       // Show tenants in the selected property for payment view
//       setIsLoadingTenants(true);
      
//       if (tenantsInPropertyQuery.data) {
//         setPaymentFilteredTenants(tenantsInPropertyQuery.data.data || []);
//         setIsLoadingTenants(false);
//       }
      
//       if (tenantsInPropertyQuery.isError) {
//         console.error('Error fetching tenants:', tenantsInPropertyQuery.error);
//         toast.error('Failed to load tenants');
//         setIsLoadingTenants(false);
//       }
//     } else {
//       // Show ALL tenants when no property is selected for payment view
//       setPaymentFilteredTenants(getAllTenants());
//     }
//   }, [filters.propertyId, TenantsData.data, tenantsInPropertyQuery.data, tenantsInPropertyQuery.isError]);

//   // Filter tenants for expense view when property or apartment is selected
//   useEffect(() => {
//     if (expenseFilters.propertyId) {
//       // Show tenants in the selected property for expense view
//       setIsLoadingTenants(true);
      
//       if (tenantsInPropertyQuery.data) {
//         setFilteredTenants(tenantsInPropertyQuery.data.data || []);
//         setIsLoadingTenants(false);
//       }
      
//       if (tenantsInPropertyQuery.isError) {
//         console.error('Error fetching tenants:', tenantsInPropertyQuery.error);
//         toast.error('Failed to load tenants');
//         setIsLoadingTenants(false);
//       }
//     } else if (expenseFilters.apartmentId) {
//       // Show tenants in the selected apartment for expense view
//       setIsLoadingTenants(true);
      
//       if (tenantsInApartmentQuery.data) {
//         setFilteredTenants(tenantsInApartmentQuery.data.data || []);
//         setIsLoadingTenants(false);
//       }
      
//       if (tenantsInApartmentQuery.isError) {
//         console.error('Error fetching tenants:', tenantsInApartmentQuery.error);
//         toast.error('Failed to load tenants');
//         setIsLoadingTenants(false);
//       }
//     } else {
//       // Show ALL tenants when no apartment or property is selected for expense view
//       setFilteredTenants(getAllTenants());
//     }
//   }, [expenseFilters.propertyId, expenseFilters.apartmentId, TenantsData.data, tenantsInPropertyQuery.data, tenantsInPropertyQuery.isError, tenantsInApartmentQuery.data, tenantsInApartmentQuery.isError]);

//   const handlePageChange = (newPage: number) => {
//     setCurrentPage(newPage - 1);
//     fetchPaymentHistory({ filter: filters, page: currentPage, size: itemsPerPage });
//   };
  
//   const handlePageSizeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
//     setItemsPerPage(Number(event.target.value));
//     setCurrentPage(0);
//     fetchPaymentHistory({ filter: filters, page: currentPage, size: itemsPerPage });
//   };
  
//   const handlePrevPage = () => {
//     if (currentPage > 0) {
//       setCurrentPage(currentPage - 1);
//     }
//   };

//   const handleNextPage = () => {
//     if (currentPage < totalPages - 1) {
//       setCurrentPage(currentPage + 1);
//     }
//   };

//   const totalPages = Math.ceil((paymentHistoryData?.data?.totalElements || 0) / itemsPerPage);

//   const startIndex = currentPage * itemsPerPage;
//   const endIndex = startIndex + itemsPerPage;
//   const currentPaymentHistory = paymentHistoryData?.data?.content?.slice(startIndex, endIndex) || [];

//   const togglePopup = () => {
//     setIsPopupOpen(!isPopupOpen);
//   };
  
//   const {
//     data: usersData,
//     isLoading: usersLoading,
//     isError: usersError,
//   } = useUsers().Users({ isActive: true , delete: false});

//   const columns = [
//     { key: "propertyName", title: "Property Name", type: "text" },
//     { key: "tenantName", title: "Tenant Name", type: "text" },
//     { key: "paymentCollectedOn", title: "Payment Collected On", type: "date" },
//     { key: "paymentCollectedBy", title: "Payment Collected By", type: "text" },
//     { key: "paymentStatus", title: "Payment Status", type: "text" }, 
//     { key: "paymentMode", title: "Payment Mode", type: "text" },
//     { key: "paymentType", title: "Payment Type", type: "text" },
//     { key: "rentOf", title: "Rent of (Month)", type: "text" },
//     { key: "amountReceived", title: " Amount Received", type: "number" },
//     { key: "balanceAmount", title: "Balance Amount", type: "number" },
//   ];

//   const transformFilters = (filters: PaymentFilter): PaymentApiParams => {
//     return {
//       tenantId: filters.tenantId,
//       propertyId: filters.propertyId,
//       paymentStatus: filters.paymentStatus,
//       fromDate: filters.paymentCollectedOnFrom,
//       toDate: filters.paymentCollectedOnTo,
//       rentOfFrom: filters.rentOfFrom,
//       rentOfTo: filters.rentOfTo,
//       maxAmountReceived: filters.maxAmountReceived,
//       maxBalanceAmount: filters.maxBalanceAmount,
//       paymentMode: filters.paymentMode,
//       paymentType: filters.paymentType,
//       paymentCollectedById: filters.paymentCollectedById,
//       page: currentPage, // Add current page
//       size: itemsPerPage, // Add items per page
//     };
//   };
  
//   const handleApplyFilters = (newFilters: PaymentFilter) => {
//     fetchPaymentHistory(
//       { filter: newFilters, page: currentPage, size: itemsPerPage },
//       {
//         onSuccess: (data) => {
//           setCurrentPage(0);
//         },
//         onError: (err: any) => {
//           console.error("Error fetching payment history:", err);
//           toast.error("Failed to fetch payment history.");
//         },
//       }
//     );
//   };

//   const handleSearch = (currentFilters: PaymentFilter = {}) => {
//     const payload: any = { ...currentFilters };

//     if (tenantIdSearch) {
//       payload.tenantId = tenantIdSearch;
//     }
//     if (userIdSearch) {
//       payload.paymentCollectedById = userIdSearch;
//     }
//     try {
//       if (Object.keys(payload).length === 0 && searchQuery === "") {
//         setErrMessage("Please provide at least one filter criteria or search query.");
//         setAlertPopup(true);
//         return;
//       }
//       fetchPaymentHistory(payload);
//     } catch (error: any) {
//       toast.error(error);
//     }
//   };
  
//   const handleClearFilters = () => {
//     setFilters({});
//     setCurrentPage(0);
//     fetchPaymentHistory({ filter: {}, page: 0, size: 25 });
//   };

//   const expenseColumns = [
//     { key: "propertyName", title: "Property Name", type: "text" },
//     { key: "tenantName", title: "Tenant Name", type: "text" },
//     { key: "expenseType", title: "Expense Type", type: "text" },
//     { key: "amount", title: "Amount", type: "number" },
//     { key: "date", title: "Expense Date", type: "date" },
//   ];

//   // Handle expense filter application
//   const handleApplyExpenseFilters = async (newFilters: ExpenseFilter) => {
//     setIsExpenseLoading(true);
//     setIsExpenseError(false);
    
//     try {
//       // Prepare the filter data for the API
//       const filterData = {
//         appartmentId: newFilters.apartmentId,
//         propertyName: filteredProperties.find(p => p.id === newFilters.propertyId)?.propertyName,
//         tenantName: filteredTenants.find(t => t.id === newFilters.tenantId)?.name,
//         expenseType: newFilters.expenseType,
//         minAmount: newFilters.amountFrom,
//         maxAmount: newFilters.amountTo,
//         fromDate: newFilters.dateFrom,
//         toDate: newFilters.dateTo
//       };
      
//       // Use the mutation from the hook
//       const result = await filterExpenses.mutateAsync(filterData);
//       setExpenseData(result);
//     } catch (error) {
//       console.error('Error fetching expense data:', error);
//       setIsExpenseError(true);
//       toast.error('Failed to fetch expense data');
//     } finally {
//       setIsExpenseLoading(false);
//     }
//   };

//   const handleViewTypeChange = (type: "payment" | "expense") => {
//     setViewType(type);
//     // Clear filters when switching views
//     setFilters({});
//     setExpenseFilters({});
//   };

//   // Handle property selection in payment filters
//   const handlePaymentPropertyChange = (propertyId: number | undefined) => {
//     setFilters({ 
//       ...filters, 
//       propertyId,
//       tenantId: undefined // Reset tenant when property changes
//     });
//   };

//   return (
//     <div className="flex flex-col lg:flex-row w-full">
//       {/* Left Side - Filter Form */}
//       <div className="w-full lg:w-1/4 p-4 lg:p-6 bg-gray-50 rounded-md shadow-md mb-4 lg:mb-0 lg:mr-4">
//         {/* View Type Selector - Moved to top of filter panel */}
//         <div className="mb-6">
//           <label className="block text-gray-700 text-sm font-bold mb-2">View Type</label>
//           <select
//             value={viewType}
//             onChange={(e) => handleViewTypeChange(e.target.value as "payment" | "expense")}
//             className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary text-sm"
//           >
//             <option value="payment">Payment History</option>
//             <option value="expense">Expenses History</option>
//           </select>
//         </div>

//         <h2 className="text-l font-semibold text-gray-800 mb-4">
//           {viewType === "payment" ? "Payment Filters" : "Expense Filters"}
//         </h2>
        
//         {viewType === "payment" ? (
//           /* Payment Filters */
//           <>
//             <div className="mb-4">
//               <label htmlFor="propertyIdFilter" className="block text-gray-700 text-sm font-bold mb-2">
//                 Property Name
//               </label>
//               <select
//                 value={filters.propertyId || ""}
//                 onChange={(e) => handlePaymentPropertyChange(Number(e.target.value) || undefined)}
//                 className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
//               >
//                 <option value="">All Properties</option>
//                 {getAllProperties().map((property: any) => (
//                   <option key={property.id} value={property.id}>
//                     {property.propertyName}
//                   </option>
//                 ))}
//               </select>
//             </div>
            
//             <div className="mb-4">
//               <label htmlFor="tenantIdFilter" className="block text-gray-700 text-sm font-bold mb-2">
//                 Tenant Name
//               </label>
//               <select
//                 value={filters.tenantId || ""}
//                 onChange={(e) => setFilters({ ...filters, tenantId: Number(e.target.value) || undefined })}
//                 className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
//                 disabled={isLoadingTenants}
//               >
//                 <option value="">All Tenants</option>
//                 {paymentFilteredTenants.map((tenant: any) => (
//                   <option key={tenant.id} value={tenant.id}>
//                     {tenant.name}
//                   </option>
//                 ))}
//               </select>
//               {isLoadingTenants && <p className="text-xs text-gray-500 mt-1">Loading tenants...</p>}
//             </div>

//     <div className="mb-4">
//       <label className="block text-gray-700 text-sm font-bold mb-2">Payment Status</label>
//       <div className="flex flex-wrap gap-2"> {/* Changed to flex-wrap for mobile */}
//         <div>
//           <input
//             type="radio"
//             id="status_paid"
//             name="paymentStatus"
//             value="PAID"
//             className="mr-1" 
//             checked={filters.paymentStatus === "PAID"}
//             onChange={(e) => setFilters({ ...filters, paymentStatus: e.target.value })}
//           />
//           <label htmlFor="status_paid" className="text-gray-600 text-sm">Fully Paid</label>
//         </div>
//         <div>
//           <input
//             type="radio"
//             id="status_partial"
//             name="paymentStatus"
//             value="PARTIAL"
//             className="mr-1"
//             checked={filters.paymentStatus === "PARTIAL"}
//             onChange={(e) => setFilters({ ...filters, paymentStatus: e.target.value })}
//           />
//           <label htmlFor="status_partial" className="text-gray-600 text-sm">Partially Paid</label>
//         </div>
//       </div>
//     </div>

//     <div className="mb-4 flex flex-col sm:flex-row gap-4"> {/* Stack vertically on mobile */}
//       <div className="w-full sm:w-1/2">
//         <label htmlFor="paymentCollectedOnFromFilter" className="block text-gray-700 text-sm font-bold mb-2">
//           Collected On From
//         </label>
//         <input
//           type="date"
//           id="paymentCollectedOnFromFilter"
//           className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
//           value={filters.paymentCollectedOnFrom || ""}
//           onChange={(e) => setFilters({ ...filters, paymentCollectedOnFrom: e.target.value || undefined })}
//         />
//       </div>
//       <div className="w-full sm:w-1/2">
//         <label htmlFor="paymentCollectedOnToFilter" className="block text-gray-700 text-sm font-bold mb-2">
//           Collected On To
//         </label>
//         <input
//           type="date"
//           id="paymentCollectedOnToFilter"
//           className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
//           value={filters.paymentCollectedOnTo || ""}
//           onChange={(e) => setFilters({ ...filters, paymentCollectedOnTo: e.target.value || undefined })}
//         />
//       </div>
//     </div>

//     <div className="mb-4">
//       <label className="block text-gray-700 text-sm font-bold mb-2">Payment Mode</label>
//       <div className="flex flex-wrap gap-2"> {/* Changed to flex-wrap for mobile */}
//         <div>
//           <input
//             type="radio"
//             id="mode_cash"
//             name="paymentMode"
//             value="CASH"
//             className="mr-1"
//             checked={filters.paymentMode === "CASH"}
//             onChange={(e) => setFilters({ ...filters, paymentMode: e.target.value })}
//           />
//           <label htmlFor="mode_cash" className="text-gray-600 text-sm">Cash</label>
//         </div>
//         <div>
//           <input
//             type="radio"
//             id="mode_upi"
//             name="paymentMode"
//             value="UPI"
//             className="mr-1"
//             checked={filters.paymentMode === "UPI"}
//             onChange={(e) => setFilters({ ...filters, paymentMode: e.target.value })}
//           />
//           <label htmlFor="mode_upi" className="text-gray-600 text-sm">UPI</label>
//         </div>
//         <div>
//           <input
//             type="radio"
//             id="mode_check"
//             name="paymentMode"
//             value="CHEQUE"
//             className="mr-1"
//             checked={filters.paymentMode === "CHEQUE"}
//             onChange={(e) => setFilters({ ...filters, paymentMode: e.target.value })}
//           />
//           <label htmlFor="mode_check" className="text-gray-600 text-sm">Cheque</label>
//         </div>
//         <div>
//           <input
//             type="radio"
//             id="mode_bank"
//             name="paymentMode"
//             value="BANKTRANSACTION"
//             className="mr-1"
//             checked={filters.paymentMode === "BANKTRANSACTION"}
//             onChange={(e) => setFilters({ ...filters, paymentMode: e.target.value })}
//           />
//           <label htmlFor="mode_bank" className="text-gray-600 text-sm">Bank Transfer</label>
//         </div>
//       </div>
//     </div>

//     <div className="mb-4">
//       <label className="block text-gray-700 text-sm font-bold mb-2">Payment Type</label>
//       <div className="flex flex-wrap gap-2"> {/* Changed to flex-wrap for mobile */}
//         <div>
//           <input
//             type="radio"
//             id="type_rent"
//             name="paymentType"
//             value="RENT"
//             className="mr-1"
//             checked={filters.paymentType === "RENT"}
//             onChange={(e) => setFilters({ ...filters, paymentType: e.target.value })}
//           />
//           <label htmlFor="type_rent" className="text-gray-600 text-sm">Rent</label>
//         </div>
//         <div>
//           <input
//             type="radio"
//             id="type_openingbalance"
//             name="paymentType"
//             value="OPENINGBALANCE"
//             className="mr-1"
//             checked={filters.paymentType === "OPENINGBALANCE"}
//             onChange={(e) => setFilters({ ...filters, paymentType: e.target.value })}
//           />
//           <label htmlFor="type_openingbalance" className="text-gray-600 text-sm">Opening Balance</label>
//         </div>
//         <div>
//           <input
//             type="radio"
//             id="type_deposit"
//             name="paymentType"
//             value="DEPOSIT"
//             className="mr-1"
//             checked={filters.paymentType === "DEPOSIT"}
//             onChange={(e) => setFilters({ ...filters, paymentType: e.target.value })}
//           />
//           <label htmlFor="type_deposit" className="text-gray-600 text-sm">Deposit</label>
//         </div>
//       </div>
//     </div>

//     <div className="mb-4 flex flex-col sm:flex-row gap-4"> {/* Stack vertically on mobile */}
//       <div className="w-full sm:w-1/2">
//         <label htmlFor="rentOfFromFilter" className="block text-gray-700 text-sm font-bold mb-2">
//           Rent Of From
//         </label>
//         <input
//           type="date"
//           id="rentOfFromFilter"
//           className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
//           value={filters.rentOfFrom || ""}
//           onChange={(e) => setFilters({ ...filters, rentOfFrom: e.target.value || undefined })}
//         />
//       </div>
//       <div className="w-full sm:w-1/2">
//         <label htmlFor="rentOfToFilter" className="block text-gray-700 text-sm font-bold mb-2">
//           Rent Of To
//         </label>
//         <input
//           type="date"
//           id="rentOfToFilter"
//           className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
//           value={filters.rentOfTo || ""}
//           onChange={(e) => setFilters({ ...filters, rentOfTo: e.target.value || undefined })}
//         />
//       </div>
//     </div>

//     <div className="mb-4">
//       <label htmlFor="maxAmountReceivedFilter" className="block text-gray-700 text-sm font-bold mb-2">
//         Max Amount Received
//       </label>
//       <input
//         type="range"
//         id="maxAmountReceivedFilter"
//         min={0}
//         max={300000}
//         value={filters.maxAmountReceived || 0}
//         className="cursor-pointer w-full bg-primary"
//         onChange={(e) => setFilters({ ...filters, maxAmountReceived: parseInt(e.target.value) || undefined })}
//       />
//       <span className="text-sm text-gray-600">Value: {filters.maxAmountReceived || 'Any'}</span>
//     </div>

//     <div className="mb-4">
//       <label htmlFor="maxBalanceAmountFilter" className="block text-gray-700 text-sm font-bold mb-2">
//         Max Balance Amount
//       </label>
//       <input
//         type="range"
//         id="maxBalanceAmountFilter"
//         min={0}
//         max={300000}
//         value={filters.maxBalanceAmount || 0}
//         className="cursor-pointer w-full bg-primary"
//         onChange={(e) => setFilters({ ...filters, maxBalanceAmount: parseInt(e.target.value) || undefined })}
//       />
//       <span className="text-sm text-gray-600">Value: {filters.maxBalanceAmount || 'Any'}</span>
//     </div>

//     <div className="mb-4">
//       <label htmlFor="paymentCollectedByIdFilter" className="block text-gray-700 text-sm font-bold mb-2">
//         Payment Collected By
//       </label>
//       <SuggestionInput
//         setActiveValue={(value: string) => setFilters({ ...filters, paymentCollectedById: undefined })}
//         activeValue={
//           usersData?.content?.find((user: any) => user.userID === filters.paymentCollectedById)?.userName || ""
//         }
//         loading={usersLoading}
//         setActiveIndex={(value: number) => {
//           setFilters({ ...filters, paymentCollectedById: usersData?.content?.[value]?.userID });
//         }}
//         suggestions={usersData?.content?.map((user: any) => user.userName) || []}
//       />
//     </div>

//     <div className="mt-6 flex flex-col sm:flex-row gap-2 sm:gap-4">
//       <button
//         className="w-full bg-primary hover:bg-secondary text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
//         onClick={() => handleApplyFilters(filters)}
//       >
//         Apply Filters
//       </button>
//       <button
//         className="w-full bg-red-400 hover:bg-red-500 text-white  font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
//         onClick={handleClearFilters}
//       >
//         Clear Filters
//       </button>
//     </div>
//       </>
//         ) : (
//           /* Expense Filters */
//           <>
//             <div className="mb-4">
//               <label className="block text-gray-700 text-sm font-bold mb-2">Apartment</label>
//               <select
//                 value={expenseFilters.apartmentId || ""}
//                 onChange={(e) => {
//                   const apartmentId = Number(e.target.value) || undefined;
//                   setExpenseFilters({ 
//                     ...expenseFilters, 
//                     apartmentId,
//                     propertyId: undefined, 
//                     tenantId: undefined 
//                   });
//                 }}
//                 className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
//                 disabled={isApartmentsLoading}
//               >
//                 <option value="">Select Apartment</option>
//                 {apartments.map((apartment) => (
//                   <option key={apartment.id} value={apartment.id}>
//                     {apartment.apartmentName}
//                   </option>
//                 ))}
//               </select>
//               {isApartmentsLoading && <p className="text-xs text-gray-500 mt-1">Loading apartments...</p>}
//             </div>

//                  <div className="mb-4">
//               <label className="block text-gray-700 text-sm font-bold mb-2">Property</label>
//               <select
//                 value={expenseFilters.propertyId || ""}
//                 onChange={(e) => {
//                   const propertyId = Number(e.target.value) || undefined;
//                   setExpenseFilters({ 
//                     ...expenseFilters, 
//                     propertyId,
//                     tenantId: undefined // Reset tenant when property changes
//                   });
//                 }}
//                 className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
//                 disabled={isLoadingProperties}
//               >
//                 <option value="">All Properties</option>
//                 {filteredProperties.map((property) => (
//                   <option key={property.id} value={property.id}>
//                     {property.propertyName}
//                   </option>
//                 ))}
//               </select>
//               {isLoadingProperties && <p className="text-xs text-gray-500 mt-1">Loading properties...</p>}
//             </div>

//             <div className="mb-4">
//               <label className="block text-gray-700 text-sm font-bold mb-2">Tenant</label>
//               <select
//                 value={expenseFilters.tenantId || ""}
//                 onChange={(e) => setExpenseFilters({ 
//                   ...expenseFilters, 
//                   tenantId: Number(e.target.value) || undefined 
//                 })}
//                 className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
//                 disabled={isLoadingTenants}
//               >
//                 <option value="">All Tenants</option>
//                 {filteredTenants.map((tenant) => (
//                   <option key={tenant.id} value={tenant.id}>
//                     {tenant.name}
//                   </option>
//                 ))}
//               </select>
//               {isLoadingTenants && <p className="text-xs text-gray-500 mt-1">Loading tenants...</p>}
//             </div>

//             <div className="mb-4">
//               <label className="block text-gray-700 text-sm font-bold mb-2">Expense Type</label>
//               <select
//                 value={expenseFilters.expenseType || ""}
//                 onChange={(e) => setExpenseFilters({ ...expenseFilters, expenseType: e.target.value || undefined })}
//                 className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
//               >
//                 <option value="">Select Type</option>
//                 <option value="PROPERTY_MANAGEMENT_FEES">Property Management Fees</option>
//                 <option value=" UTILITIES">Utilities</option>
//                 <option value="REPAIRS_AND_MAINTENANCE">Repairs & Maintenance</option>
//                 <option value="GARDEN_AND_LAWN_CARE">Garden and lawn care</option>
//                 <option value="CLEANING">Cleaning</option>
//                  <option value="PEST_CONTROL">Pest Control</option>
//                   <option value="PROPERTY_TAXES">Property Taxes</option>
//                    <option value="SOCIETY_ASSOCIATION_FEES">Society/ Association Fees</option>
//                     <option value="SECURITY_AND_MONITORING">Security & Monitoring</option>
//                      <option value="LEASING_COSTS">Leasing Costs</option>
//                    <option value="LEGAL_AND_PROFESSIONAL_FEES">Legal & Professional Fees</option>
//                       <option value="HOUSEHOLD_SUPPLIES">Household Supplies</option>
//               </select>
//             </div>

//            <div className="mb-4">
//               <label htmlFor="maxExpenseAmountFilter" className="block text-gray-700 text-sm font-bold mb-2">
//                 Max Expense Amount
//               </label>
//               <input
//                 type="range"
//                 id="maxExpenseAmountFilter"
//                 min={0}
//                 max={30000}
//                 value={expenseFilters.amountTo || 0}
//                 className="cursor-pointer w-full bg-primary"
//                 onChange={(e) => setExpenseFilters({ ...expenseFilters, amountTo: parseInt(e.target.value) || undefined })}
//               />
//               <span className="text-sm text-gray-600">Value: {expenseFilters.amountTo || 'Any'}</span>
//             </div>

//             <div className="mb-4 flex flex-col sm:flex-row gap-4">
//               <div className="w-full sm:w-1/2">
//                 <label className="block text-gray-700 text-sm font-bold mb-2">Date From</label>
//                 <input
//                   type="date"
//                   value={expenseFilters.dateFrom || ""}
//                   onChange={(e) => setExpenseFilters({ ...expenseFilters, dateFrom: e.target.value || undefined })}
//                   className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
//                 />
//               </div>
//               <div className="w-full sm:w-1/2">
//                 <label className="block text-gray-700 text-sm font-bold mb-2">Date To</label>
//                 <input
//                   type="date"
//                   value={expenseFilters.dateTo || ""}
//                   onChange={(e) => setExpenseFilters({ ...expenseFilters, dateTo: e.target.value || undefined })}
//                   className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
//                 />
//               </div>
//             </div>

//             <div className="mt-6 flex flex-col sm:flex-row gap-2 sm:gap-4">
//               <button
//                 className="w-full bg-primary hover:bg-secondary text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
//                 onClick={() => handleApplyExpenseFilters(expenseFilters)}
//                 disabled={filterExpenses.isPending}
//               >
//                 {filterExpenses.isPending ? "Applying..." : "Apply Filters"}
//               </button>
//               <button
//                 className="w-full bg-red-400 hover:bg-red-500 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
//                 onClick={() => setExpenseFilters({})}
//               >
//                 Clear Filters
//               </button>
//             </div>
//           </>

//         )}
//       </div>

//   {/* Right Side - Table */}
//   <div className="w-full lg:w-3/4 p-2 sm:p-4">
//     <header className="mb-4">
//       <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2">
//         {/* <h1 className="text-xl sm:text-2xl font-bold">Reports</h1> */}
//          <h1 className="text-xl sm:text-2xl font-bold">
//               {viewType === "payment" ? "Payment Reports" : "Expense Reports"}
//             </h1>
//         <button
//           className="bg-primary text-white flex gap-1 justify-center hover:bg-secondary rounded-lg px-4 py-2 text-sm"
//           onClick={togglePopup}
//         >
//           Export
//         </button>
//       </div>
//     </header>
//     <div className="min-w-full overflow-x-auto">
//        {viewType === "payment" ? (
//       <Table
//         columns={columns as any}
//         loading={isPaymentHistoryLoading}
//         data={paymentHistoryData?.data?.content || []}
//       />
//        ) : (
//             /* Expense Table */
//             <Table
//               columns={expenseColumns as any}
//               loading={isExpenseLoading}
//                data={expenseData?.data?.content || []}
//             />
//           )}
//    {/* Display appropriate messages based on view type */}
//           {viewType === "payment" ? (
//             <>
//       {isPaymentHistoryError && <p className="text-red-500 mt-2">Error loading payment history.</p>}
//       {isPaymentHistoryLoading && <p className="text-gray-500 mt-2">Loading payment history...</p>}
//       {!isPaymentHistoryLoading &&
//         !isPaymentHistoryError &&
//         (!paymentHistoryData?.data?.content || paymentHistoryData.data.content.length === 0) && (
//         <div className="w-full h-20 flex justify-center items-center">
//           <p className="text-gray-600 mt-2 flex items-center">
//             No payment history available based on the filters.
//           </p>
//         </div>
//       )}
//         </>
//           ) : (
//           <>
//               {isExpenseError && <p className="text-red-500 mt-2">Error loading expense history.</p>}
//               {isExpenseLoading && <p className="text-gray-500 mt-2">Loading expense history...</p>}
//               {!isExpenseLoading && 
//                 !isExpenseError && 
//                 (!expenseData?.data?.content || expenseData.data.content.length === 0) && (
//                 <div className="w-full h-20 flex justify-center items-center">
//                   <p className="text-gray-600 mt-2 flex items-center">
//                     No expense history available based on the filters.
//                   </p>
//                 </div>
//               )}
//             </>
//           )}


//       {/* Pagination Controls */}
//       {!isPaymentHistoryLoading && paymentHistoryData?.data?.content?.length > 0 && (
//         <div className="flex flex-col sm:flex-row justify-between items-center mt-4 gap-2">
//           {/* Page size selection */}
//           <div className="flex items-center space-x-2">
//             <span className="text-gray-700 text-sm">Items per page:</span>
//             <select
//               value={itemsPerPage}
//               onChange={handlePageSizeChange}
//               className="border border-gray-300 rounded-md py-1 px-2 text-gray-700 focus:outline-none text-sm"
//             >
//               {pageSizeOptions.map((size) => (
//                 <option key={size} value={size}>
//                   {size}
//                 </option>
//               ))}
//             </select>
//           </div>

//           {/* Pagination buttons */}
//           <div className="flex items-center space-x-2">
//             <button
//               onClick={() => handlePageChange(1)}
//               disabled={currentPage + 1 === 1}
//               className="px-3 py-1 bg-gray-200 rounded-md hover:bg-gray-300 text-sm"
//             >
//               &lt;&lt;
//             </button>
//             <button
//               onClick={handlePrevPage}
//               disabled={currentPage + 1 === 1}
//               className="px-3 py-1 bg-gray-200 rounded-md hover:bg-gray-300 text-sm"
//             >
//               &lt;
//             </button>
//             <span className="px-3 py-1 text-white bg-primary rounded-md text-sm">
//               {currentPage + 1}
//             </span>
//             <button
//               onClick={handleNextPage}
//               disabled={currentPage + 1 === totalPages}
//               className="px-3 py-1 bg-gray-200 rounded-md hover:bg-gray-300 text-sm"
//             >
//               &gt;
//             </button>
//             <button
//               onClick={() => handlePageChange(totalPages)}
//               disabled={currentPage + 1 === totalPages}
//               className="px-3 py-1 bg-gray-200 rounded-md hover:bg-gray-300 text-sm"
//             >
//               &gt;&gt;
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   </div>

//       {/* Export Popup */}
//       {isPopupOpen && (
//         <Popup onClose={togglePopup}>
//           {viewType === "payment" ? (
//             paymentHistoryData?.data?.content?.length > 0 ? (
//               <ExportPopup
//                 data={paymentHistoryData.data.content}
//                 onClose={togglePopup}
//                  filename={`${viewType}_report`}
//               />
//             ) : (
//               <div style={{
//                 padding: '20px',
//                 background: '#f9f9f9',
//                 border: '1px solid #ccc',
//                 borderRadius: '5px',
//                 display: 'flex',
//                 flexDirection: 'column',
//                 alignItems: 'center',
//                 gap: '15px',
//               }}>
//                 <div style={{ fontWeight: 'bold', marginBottom: '10px' }}>No payment history available.</div>
//                 <button
//                   onClick={togglePopup}
//                   style={{
//                     padding: '8px 15px',
//                     background: '#09ba39',
//                     color: 'white',
//                     border: 'none',
//                     borderRadius: '5px',
//                     cursor: 'pointer'
//                   }}
//                 >
//                   Close
//                 </button>
//               </div>
//             )
//           ) : (
//             expenseData?.data?.content?.length > 0 ? (
//               <ExportPopup
//                 data={expenseData.data.content}
//                 onClose={togglePopup}
//                  filename={`${viewType}_report`}
//               />
//             ) : (
//               <div style={{
//                 padding: '20px',
//                 background: '#f9f9f9',
//                 border: '1px solid #ccc',
//                 borderRadius: '5px',
//                 display: 'flex',
//                 flexDirection: 'column',
//                 alignItems: 'center',
//                 gap: '15px',
//               }}>
//                 <div style={{ fontWeight: 'bold', marginBottom: '10px' }}>No expense history available.</div>
//                 <button
//                   onClick={togglePopup}
//                   style={{
//                     padding: '8px 15px',
//                     background: '#09ba39',
//                     color: 'white',
//                     border: 'none',
//                     borderRadius: '5px',
//                     cursor: 'pointer'
//                   }}
//                 >
//                   Close
//                 </button>
//               </div>
//             )
//           )}
//         </Popup>
//       )}

//       <AlertPopup
//         alertPopup={alertPopup}
//         setAlertPopup={setAlertPopup}
//         errMessage={errmessage}
//       />
//     </div>
//   );
// };

// export default PaymentHistory;


import React, { useEffect, useState } from "react";
import Table from "../Common/Table/main";
import SearchBar from "../Common/SearchBar/main";
import { Dayjs } from "dayjs";
import { usePayments } from "../../hook/usePayments";
import { useTenants } from "../../hook/useTenents";

import { useUsers } from "../../hook/useUsers";
import { DatePicker, DatePickerProps } from "antd";
import { Popup } from "../Common/Popup/main";
import AlertPopup from "../Popups/alertPopup";
import ExportPopup from "../Popups/exportPopup";
import toast from "react-hot-toast";
import SuggestionInput from "../Common/SuggestionInput/main";
import { RiMoneyRupeeCircleFill } from "react-icons/ri";
import Dropdown from "../Common/Dropdown/main";
import { FaUser } from "react-icons/fa";
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import { useProperties } from "../../hook/useProperties";
import { useApartment } from "../../hook/useApartment";

interface Payment {
  id: number;
  tenantName: string;
  paymentStatus: string;
  paymentCollectedOn: string | null;
  paymentCollectedBy: string | null;
  rentOf: string;
  balanceAmount: number;
  amountReceived: number;
  paymentMode: string | null;
  paymentType: string;
}

interface ExpenseFilter {
  apartmentId?: number;
  propertyId?: number;
  tenantId?: number;
  expenseType?: string;
  amountFrom?: number;
  amountTo?: number;
  dateFrom?: string;
  dateTo?: string;
  page?: number;
  size?: number;
}

interface PaymentFilter {
  propertyId?: number,
  tenantId?: number;
  paymentStatus?: string;
  paymentCollectedOnFrom?: string;
  paymentCollectedOnTo?: string;
  rentOfFrom?: string;
  rentOfTo?: string;
  maxAmountReceived?: number;
  maxBalanceAmount?: number;
  paymentMode?: string;
  paymentType?: string;
  paymentCollectedById?: number;
}

interface PaymentApiParams {
  propertyId?: number,
  tenantId?: number;
  paymentStatus?: string;
  fromDate?: string;
  toDate?: string;
  rentOfFrom?: string;
  rentOfTo?: string;
  maxAmountReceived?: number;
  maxBalanceAmount?: number;
  paymentMode?: string;
  paymentType?: string;
  paymentCollectedById?: number;
  page?: number;
  size?: number;
}

interface Apartment {
  id: number;
  apartmentName: string;
}

interface Property {
  id: number;
  propertyName: string;
  apartmentId?: number;
}

interface Tenant {
  id: number;
  name: string;
  propertyId?: number;
  apartmentId?: number;
}

const PaymentHistory: React.FC = () => {
  const [viewType, setViewType] = useState<"payment" | "expense">("payment");
  const [filters, setFilters] = useState<PaymentFilter>({});
  const [expenseFilters, setExpenseFilters] = useState<ExpenseFilter>({});

  const { PaymentHistory: fetchPaymentHistoryMutation } = usePayments();
  const { 
    Apartment: useApartments,
    useGetPropertiesInApartment,
    useGetTenantsInProperty,
    useGetTenantsInApartment,
    filterExpenses
  } = useApartment();
  
  const {
    data: paymentHistoryData,
    isPending: isPaymentHistoryLoading,
    isError: isPaymentHistoryError,
    error: paymentHistoryError,
    mutate: fetchPaymentHistory,
  } = fetchPaymentHistoryMutation;
  
  const [expenseData, setExpenseData] = useState<any>(null);
  const [isExpenseLoading, setIsExpenseLoading] = useState(false);
  const [isExpenseError, setIsExpenseError] = useState(false);
  
  const { _Tenants } = useTenants();
  const TenantsData = _Tenants() as any;
  const { Property } = useProperties();
  const PropertiesData = Property({ active: true, delete: false, page: 0, size: 10000 }) as any;
  const UsersData = useUsers() as any;
  
  const [searchQuery, setSearchQuery] = useState("");
  const [alertPopup, setAlertPopup] = useState<boolean>(false);
  const [errmessage, setErrMessage] = useState("");
  const [tenantIdSearch, setTenantIdSearch] = useState<any>();
  const [userIdSearch, setUserIdSearch] = useState<any>();
  const [paymentCollectedByName, setPaymentCollectedByName] = useState<string>("");
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isFilterPopupOpen, setIsFilterPopupOpen] = useState(false);
  const [paymentStatusOpen, setPaymentStatusOpen] = useState(false);
  const [paymentModeOpen, setPaymentModeOpen] = useState(false);
  const [paymentTypeOpen, setPaymentTypeOpen] = useState(false);
   const [allExpenseData, setAllExpenseData] = useState<any>(null);
  const [paginatedExpenseData, setPaginatedExpenseData] = useState<any>(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10); 
  const pageSizeOptions = [10, 25, 50, 100];
   const [expenseCurrentPage, setExpenseCurrentPage] = useState(0);
  const [expenseItemsPerPage, setExpenseItemsPerPage] = useState(10);
  const [expenseTotalPages, setExpenseTotalPages] = useState(0);

  const [apartments, setApartments] = useState<Apartment[]>([]);
  const [properties, setProperties] = useState<Property[]>([]);
  const [filteredProperties, setFilteredProperties] = useState<Property[]>([]);
  const [tenants, setTenants] = useState<Tenant[]>([]);
  const [filteredTenants, setFilteredTenants] = useState<Tenant[]>([]);
  const [paymentFilteredTenants, setPaymentFilteredTenants] = useState<Tenant[]>([]);
  const [isLoadingApartments, setIsLoadingApartments] = useState(false);
  const [isLoadingProperties, setIsLoadingProperties] = useState(false);
  const [isLoadingTenants, setIsLoadingTenants] = useState(false);
 const [paymentStartItem, setPaymentStartItem] = useState(1);
  const [paymentEndItem, setPaymentEndItem] = useState(0);
  const [paymentTotalItems, setPaymentTotalItems] = useState(0);
  
  const [expenseStartItem, setExpenseStartItem] = useState(1);
  const [expenseEndItem, setExpenseEndItem] = useState(0);
  const [expenseTotalItems, setExpenseTotalItems] = useState(0);
  // Use the apartment hook to fetch apartments
  const { data: apartmentsData, isLoading: isApartmentsLoading } = useApartments({ 
    active: true, 
    delete: false 
  });

  // Call the hooks at the top level (not inside useEffect)
  const propertiesInApartmentQuery = useGetPropertiesInApartment(expenseFilters.apartmentId || 0);
  const tenantsInPropertyQuery = useGetTenantsInProperty(filters.propertyId || expenseFilters.propertyId || 0);
  const tenantsInApartmentQuery = useGetTenantsInApartment(expenseFilters.apartmentId || 0);

  // Get all properties and tenants for initial display (like payment filters)
  const getAllProperties = () => {
    if (PropertiesData.data) {
      return [
        ...(PropertiesData.data?.data?.COMMERCIAL || []),
        ...(PropertiesData.data?.data?.RESIDENTIAL || [])
      ];
    }
    return [];
  };

  const getAllTenants = () => {
    if (TenantsData.data) {
      return [
        ...(TenantsData.data?.data?.commercialTenants || []),
        ...(TenantsData.data?.data?.residentialTenants || [])
      ];
    }
    return [];
  };

  // Set apartments data when loaded
  useEffect(() => {
    if (apartmentsData?.data?.content) {
      setApartments(apartmentsData.data.content);
    }
  }, [apartmentsData]);

  // Set properties data when loaded from PropertiesData
  useEffect(() => {
    const allProperties = getAllProperties();
    setProperties(allProperties);
    setFilteredProperties(allProperties);
  }, [PropertiesData.data]);

  // Set tenants data when loaded from TenantsData
  useEffect(() => {
    const allTenants = getAllTenants();
    setTenants(allTenants);
    setFilteredTenants(allTenants);
    setPaymentFilteredTenants(allTenants);
  }, [TenantsData.data]);

  // Filter properties when apartment is selected
  useEffect(() => {
    if (expenseFilters.apartmentId) {
      setIsLoadingProperties(true);
      
      if (propertiesInApartmentQuery.data) {
        setFilteredProperties(propertiesInApartmentQuery.data.data || []);
        setIsLoadingProperties(false);
      }
      
      if (propertiesInApartmentQuery.isError) {
        console.error('Error fetching properties:', propertiesInApartmentQuery.error);
        toast.error('Failed to load properties');
        setIsLoadingProperties(false);
      }
    } else {
      // Show ALL properties when no apartment is selected
      setFilteredProperties(getAllProperties());
    }
  }, [expenseFilters.apartmentId, PropertiesData.data, propertiesInApartmentQuery.data, propertiesInApartmentQuery.isError]);

  // Filter tenants for payment view when property is selected
  useEffect(() => {
    if (filters.propertyId) {
      // Show tenants in the selected property for payment view
      setIsLoadingTenants(true);
      
      if (tenantsInPropertyQuery.data) {
        setPaymentFilteredTenants(tenantsInPropertyQuery.data.data || []);
        setIsLoadingTenants(false);
      }
      
      if (tenantsInPropertyQuery.isError) {
        console.error('Error fetching tenants:', tenantsInPropertyQuery.error);
        toast.error('Failed to load tenants');
        setIsLoadingTenants(false);
      }
    } else {
      // Show ALL tenants when no property is selected for payment view
      setPaymentFilteredTenants(getAllTenants());
    }
  }, [filters.propertyId, TenantsData.data, tenantsInPropertyQuery.data, tenantsInPropertyQuery.isError]);

  // Filter tenants for expense view when property or apartment is selected
  useEffect(() => {
    if (expenseFilters.propertyId) {
      // Show tenants in the selected property for expense view
      setIsLoadingTenants(true);
      
      if (tenantsInPropertyQuery.data) {
        setFilteredTenants(tenantsInPropertyQuery.data.data || []);
        setIsLoadingTenants(false);
      }
      
      if (tenantsInPropertyQuery.isError) {
        console.error('Error fetching tenants:', tenantsInPropertyQuery.error);
        toast.error('Failed to load tenants');
        setIsLoadingTenants(false);
      }
    } else if (expenseFilters.apartmentId) {
      // Show tenants in the selected apartment for expense view
      setIsLoadingTenants(true);
      
      if (tenantsInApartmentQuery.data) {
        setFilteredTenants(tenantsInApartmentQuery.data.data || []);
        setIsLoadingTenants(false);
      }
      
      if (tenantsInApartmentQuery.isError) {
        console.error('Error fetching tenants:', tenantsInApartmentQuery.error);
        toast.error('Failed to load tenants');
        setIsLoadingTenants(false);
      }
    } else {
      // Show ALL tenants when no apartment or property is selected for expense view
      setFilteredTenants(getAllTenants());
    }
  }, [expenseFilters.propertyId, expenseFilters.apartmentId, TenantsData.data, tenantsInPropertyQuery.data, tenantsInPropertyQuery.isError, tenantsInApartmentQuery.data, tenantsInApartmentQuery.isError]);

  // Fetch payment history when filters, page, or itemsPerPage change
  useEffect(() => {
    if (viewType === "payment") {
      fetchPaymentHistory({
        filter: filters,
        page: currentPage,
        size: itemsPerPage
      });
    }
  }, [filters, currentPage, itemsPerPage, viewType]);

  useEffect(() => {
    if (paymentHistoryData?.data) {
      const totalElements = paymentHistoryData.data.totalElements || 0;
      const contentLength = paymentHistoryData.data.content?.length || 0;
      
      setPaymentTotalItems(totalElements);
      setPaymentStartItem(currentPage * itemsPerPage + 1);
      setPaymentEndItem(Math.min((currentPage + 1) * itemsPerPage, totalElements));
    }
  }, [paymentHistoryData, currentPage, itemsPerPage]);

  // Add this useEffect to update expense item ranges when data changes
  useEffect(() => {
    if (expenseData?.data) {
      const totalElements = expenseData.data.totalElements || 0;
      const contentLength = expenseData.data.content?.length || 0;
      
      setExpenseTotalItems(totalElements);
      setExpenseStartItem(expenseCurrentPage * expenseItemsPerPage + 1);
      setExpenseEndItem(Math.min((expenseCurrentPage + 1) * expenseItemsPerPage, totalElements));
    }
  }, [expenseData, expenseCurrentPage, expenseItemsPerPage]);

  
  // Update the useEffect to handle frontend pagination for expenses
  useEffect(() => {
    if (allExpenseData?.data?.content) {
      const startIndex = expenseCurrentPage * expenseItemsPerPage;
      const endIndex = startIndex + expenseItemsPerPage;
      const paginatedData = {
        ...allExpenseData,
        data: {
          ...allExpenseData.data,
          content: allExpenseData.data.content.slice(startIndex, endIndex),
          totalElements: allExpenseData.data.content.length,
          totalPages: Math.ceil(allExpenseData.data.content.length / expenseItemsPerPage)
        }
      };
      setPaginatedExpenseData(paginatedData);
      
      // Update the item range display
      setExpenseTotalItems(allExpenseData.data.content.length);
      setExpenseStartItem(startIndex + 1);
      setExpenseEndItem(Math.min(endIndex, allExpenseData.data.content.length));
      setExpenseTotalPages(Math.ceil(allExpenseData.data.content.length / expenseItemsPerPage));
    }
  }, [allExpenseData, expenseCurrentPage, expenseItemsPerPage]);

  const handlePageChange = (newPage: number) => {
    setCurrentPage(newPage - 1);
  };
  
  const handlePageSizeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newSize = Number(event.target.value);
    setItemsPerPage(newSize);
    setCurrentPage(0); // Reset to first page when changing page size
  };
  
  const handlePrevPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  const totalPages = Math.ceil((paymentHistoryData?.data?.totalElements || 0) / itemsPerPage);

  const togglePopup = () => {
    setIsPopupOpen(!isPopupOpen);
  };
  
  const {
    data: usersData,
    isLoading: usersLoading,
    isError: usersError,
  } = useUsers().Users({ isActive: true , delete: false});

  const columns = [
    { key: "propertyName", title: "Property Name", type: "text" },
    { key: "tenantName", title: "Tenant Name", type: "text" },
    { key: "paymentCollectedOn", title: "Payment Collected On", type: "date" },
    { key: "paymentCollectedBy", title: "Payment Collected By", type: "text" },
    { key: "paymentStatus", title: "Payment Status", type: "text" }, 
    { key: "paymentMode", title: "Payment Mode", type: "text" },
    { key: "paymentType", title: "Payment Type", type: "text" },
    { key: "rentOf", title: "Rent of (Month)", type: "text" },
    { key: "amountReceived", title: " Amount Received", type: "number" },
    { key: "balanceAmount", title: "Balance Amount", type: "number" },
  ];

  const transformFilters = (filters: PaymentFilter): PaymentApiParams => {
    return {
      tenantId: filters.tenantId,
      propertyId: filters.propertyId,
      paymentStatus: filters.paymentStatus,
      fromDate: filters.paymentCollectedOnFrom,
      toDate: filters.paymentCollectedOnTo,
      rentOfFrom: filters.rentOfFrom,
      rentOfTo: filters.rentOfTo,
      maxAmountReceived: filters.maxAmountReceived,
      maxBalanceAmount: filters.maxBalanceAmount,
      paymentMode: filters.paymentMode,
      paymentType: filters.paymentType,
      paymentCollectedById: filters.paymentCollectedById,
      page: currentPage,
      size: itemsPerPage,
    };
  };
  
  const handleApplyFilters = (newFilters: PaymentFilter) => {
    setFilters(newFilters);
    setCurrentPage(0); // Reset to first page when applying new filters
  };

  const handleSearch = (currentFilters: PaymentFilter = {}) => {
    const payload: any = { ...currentFilters };

    if (tenantIdSearch) {
      payload.tenantId = tenantIdSearch;
    }
    if (userIdSearch) {
      payload.paymentCollectedById = userIdSearch;
    }
    try {
      if (Object.keys(payload).length === 0 && searchQuery === "") {
        setErrMessage("Please provide at least one filter criteria or search query.");
        setAlertPopup(true);
        return;
      }
      fetchPaymentHistory(payload);
    } catch (error: any) {
      toast.error(error);
    }
  };
  
  const handleClearFilters = () => {
    setFilters({});
    setCurrentPage(0);
  };

  const expenseColumns = [
    { key: "propertyName", title: "Property Name", type: "text" },
    { key: "tenantName", title: "Tenant Name", type: "text" },
    { key: "expenseType", title: "Expense Type", type: "text" },
    { key: "amount", title: "Amount", type: "number" },
    { key: "date", title: "Expense Date", type: "date" },
  ];
useEffect(() => {
  if (expenseData?.data) {
    setExpenseTotalPages(Math.ceil((expenseData.data.totalElements || 0) / expenseItemsPerPage));
  }
}, [expenseData, expenseItemsPerPage]);
  // Handle expense filter application
  const handleApplyExpenseFilters = async (newFilters: ExpenseFilter) => {
    setIsExpenseLoading(true);
    setIsExpenseError(false);
    
    try {
      // Prepare the filter data for the API
      const filterData = {
        appartmentId: newFilters.apartmentId,
        propertyName: filteredProperties.find(p => p.id === newFilters.propertyId)?.propertyName,
        tenantName: filteredTenants.find(t => t.id === newFilters.tenantId)?.name,
        expenseType: newFilters.expenseType,
        minAmount: newFilters.amountFrom,
        maxAmount: newFilters.amountTo,
        fromDate: newFilters.dateFrom,
        toDate: newFilters.dateTo,

      };
      
      // Use the mutation from the hook
      const result = await filterExpenses.mutateAsync(filterData);
      setAllExpenseData(result);
     
    } catch (error) {
      console.error('Error fetching expense data:', error);
      setIsExpenseError(true);
      toast.error('Failed to fetch expense data');
    } finally {
      setIsExpenseLoading(false);
    }
  };

  // const handleViewTypeChange = (type: "payment" | "expense") => {
  //   setViewType(type);
  //   // Clear filters when switching views
  //   setFilters({});
  //   setExpenseFilters({});
  //   setCurrentPage(0);
  // };

  // Handle property selection in payment filters
  const handlePaymentPropertyChange = (propertyId: number | undefined) => {
    setFilters({ 
      ...filters, 
      propertyId,
      tenantId: undefined // Reset tenant when property changes
    });
  };
// Add expense pagination handlers
  const handleExpensePageChange = (newPage: number) => {
    setExpenseCurrentPage(newPage - 1);
  };
  
  const handleExpensePageSizeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newSize = Number(event.target.value);
    setExpenseItemsPerPage(newSize);
    setExpenseCurrentPage(0);
  };
  
  const handleExpensePrevPage = () => {
    if (expenseCurrentPage > 0) {
      setExpenseCurrentPage(expenseCurrentPage - 1);
    }
  };

   const handleExpenseNextPage = () => {
    if (expenseCurrentPage < expenseTotalPages - 1) {
      setExpenseCurrentPage(expenseCurrentPage + 1);
    }
  };

  // Update the view type change handler to reset both paginations
  const handleViewTypeChange = (type: "payment" | "expense") => {
    setViewType(type);
    // Clear filters and reset pagination when switching views
    setFilters({});
    setExpenseFilters({});
    setCurrentPage(0);
    setExpenseCurrentPage(0);
  };



 useEffect(() => {
    if (viewType === "expense" && Object.keys(expenseFilters).length > 0) {
      handleApplyExpenseFilters(expenseFilters);
    }
  }, [expenseCurrentPage, expenseItemsPerPage, viewType]);


  return (
    <div className="flex flex-col lg:flex-row w-full">
      {/* Left Side - Filter Form */}
      <div className="w-full lg:w-1/4 p-4 lg:p-6 bg-gray-50 rounded-md shadow-md mb-4 lg:mb-0 lg:mr-4">
        {/* View Type Selector - Moved to top of filter panel */}
        <div className="mb-6">
          <label className="block text-gray-700 text-sm font-bold mb-2">View Type</label>
          <select
            value={viewType}
            onChange={(e) => handleViewTypeChange(e.target.value as "payment" | "expense")}
            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary text-sm"
          >
            <option value="payment">Payment History</option>
            <option value="expense">Expenses History</option>
          </select>
        </div>

        <h2 className="text-l font-semibold text-gray-800 mb-4">
          {viewType === "payment" ? "Payment Filters" : "Expense Filters"}
        </h2>
        
        {viewType === "payment" ? (
          /* Payment Filters */
          <>
            <div className="mb-4">
              <label htmlFor="propertyIdFilter" className="block text-gray-700 text-sm font-bold mb-2">
                Property Name
              </label>
              <select
                value={filters.propertyId || ""}
                onChange={(e) => handlePaymentPropertyChange(Number(e.target.value) || undefined)}
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              >
                <option value="">All Properties</option>
                {getAllProperties().map((property: any) => (
                  <option key={property.id} value={property.id}>
                    {property.propertyName}
                  </option>
                ))}
              </select>
            </div>
            
            <div className="mb-4">
              <label htmlFor="tenantIdFilter" className="block text-gray-700 text-sm font-bold mb-2">
                Tenant Name
              </label>
              <select
                value={filters.tenantId || ""}
                onChange={(e) => setFilters({ ...filters, tenantId: Number(e.target.value) || undefined })}
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                disabled={isLoadingTenants}
              >
                <option value="">All Tenants</option>
                {paymentFilteredTenants.map((tenant: any) => (
                  <option key={tenant.id} value={tenant.id}>
                    {tenant.name}
                  </option>
                ))}
              </select>
              {isLoadingTenants && <p className="text-xs text-gray-500 mt-1">Loading tenants...</p>}
            </div>

    <div className="mb-4">
      <label className="block text-gray-700 text-sm font-bold mb-2">Payment Status</label>
      <div className="flex flex-wrap gap-2"> {/* Changed to flex-wrap for mobile */}
        <div>
          <input
            type="radio"
            id="status_paid"
            name="paymentStatus"
            value="PAID"
            className="mr-1" 
            checked={filters.paymentStatus === "PAID"}
            onChange={(e) => setFilters({ ...filters, paymentStatus: e.target.value })}
          />
          <label htmlFor="status_paid" className="text-gray-600 text-sm">Fully Paid</label>
        </div>
        <div>
          <input
            type="radio"
            id="status_partial"
            name="paymentStatus"
            value="PARTIAL"
            className="mr-1"
            checked={filters.paymentStatus === "PARTIAL"}
            onChange={(e) => setFilters({ ...filters, paymentStatus: e.target.value })}
          />
          <label htmlFor="status_partial" className="text-gray-600 text-sm">Partially Paid</label>
        </div>
      </div>
    </div>

    <div className="mb-4 flex flex-col sm:flex-row gap-4"> {/* Stack vertically on mobile */}
      <div className="w-full sm:w-1/2">
        <label htmlFor="paymentCollectedOnFromFilter" className="block text-gray-700 text-sm font-bold mb-2">
          Collected On From
        </label>
        <input
          type="date"
          id="paymentCollectedOnFromFilter"
          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          value={filters.paymentCollectedOnFrom || ""}
          onChange={(e) => setFilters({ ...filters, paymentCollectedOnFrom: e.target.value || undefined })}
        />
      </div>
      <div className="w-full sm:w-1/2">
        <label htmlFor="paymentCollectedOnToFilter" className="block text-gray-700 text-sm font-bold mb-2">
          Collected On To
        </label>
        <input
          type="date"
          id="paymentCollectedOnToFilter"
          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          value={filters.paymentCollectedOnTo || ""}
          onChange={(e) => setFilters({ ...filters, paymentCollectedOnTo: e.target.value || undefined })}
        />
      </div>
    </div>

    <div className="mb-4">
      <label className="block text-gray-700 text-sm font-bold mb-2">Payment Mode</label>
      <div className="flex flex-wrap gap-2"> {/* Changed to flex-wrap for mobile */}
        <div>
          <input
            type="radio"
            id="mode_cash"
            name="paymentMode"
            value="CASH"
            className="mr-1"
            checked={filters.paymentMode === "CASH"}
            onChange={(e) => setFilters({ ...filters, paymentMode: e.target.value })}
          />
          <label htmlFor="mode_cash" className="text-gray-600 text-sm">Cash</label>
        </div>
        <div>
          <input
            type="radio"
            id="mode_upi"
            name="paymentMode"
            value="UPI"
            className="mr-1"
            checked={filters.paymentMode === "UPI"}
            onChange={(e) => setFilters({ ...filters, paymentMode: e.target.value })}
          />
          <label htmlFor="mode_upi" className="text-gray-600 text-sm">UPI</label>
        </div>
        <div>
          <input
            type="radio"
            id="mode_check"
            name="paymentMode"
            value="CHEQUE"
            className="mr-1"
            checked={filters.paymentMode === "CHEQUE"}
            onChange={(e) => setFilters({ ...filters, paymentMode: e.target.value })}
          />
          <label htmlFor="mode_check" className="text-gray-600 text-sm">Cheque</label>
        </div>
        <div>
          <input
            type="radio"
            id="mode_bank"
            name="paymentMode"
            value="BANKTRANSACTION"
            className="mr-1"
            checked={filters.paymentMode === "BANKTRANSACTION"}
            onChange={(e) => setFilters({ ...filters, paymentMode: e.target.value })}
          />
          <label htmlFor="mode_bank" className="text-gray-600 text-sm">Bank Transfer</label>
        </div>
      </div>
    </div>

    <div className="mb-4">
      <label className="block text-gray-700 text-sm font-bold mb-2">Payment Type</label>
      <div className="flex flex-wrap gap-2"> {/* Changed to flex-wrap for mobile */}
        <div>
          <input
            type="radio"
            id="type_rent"
            name="paymentType"
            value="RENT"
            className="mr-1"
            checked={filters.paymentType === "RENT"}
            onChange={(e) => setFilters({ ...filters, paymentType: e.target.value })}
          />
          <label htmlFor="type_rent" className="text-gray-600 text-sm">Rent</label>
        </div>
        <div>
          <input
            type="radio"
            id="type_openingbalance"
            name="paymentType"
            value="OPENINGBALANCE"
            className="mr-1"
            checked={filters.paymentType === "OPENINGBALANCE"}
            onChange={(e) => setFilters({ ...filters, paymentType: e.target.value })}
          />
          <label htmlFor="type_openingbalance" className="text-gray-600 text-sm">Opening Balance</label>
        </div>
        <div>
          <input
            type="radio"
            id="type_deposit"
            name="paymentType"
            value="DEPOSIT"
            className="mr-1"
            checked={filters.paymentType === "DEPOSIT"}
            onChange={(e) => setFilters({ ...filters, paymentType: e.target.value })}
          />
          <label htmlFor="type_deposit" className="text-gray-600 text-sm">Deposit</label>
        </div>
      </div>
    </div>

    <div className="mb-4 flex flex-col sm:flex-row gap-4"> {/* Stack vertically on mobile */}
      <div className="w-full sm:w-1/2">
        <label htmlFor="rentOfFromFilter" className="block text-gray-700 text-sm font-bold mb-2">
          Rent Of From
        </label>
        <input
          type="date"
          id="rentOfFromFilter"
          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          value={filters.rentOfFrom || ""}
          onChange={(e) => setFilters({ ...filters, rentOfFrom: e.target.value || undefined })}
        />
      </div>
      <div className="w-full sm:w-1/2">
        <label htmlFor="rentOfToFilter" className="block text-gray-700 text-sm font-bold mb-2">
          Rent Of To
        </label>
        <input
          type="date"
          id="rentOfToFilter"
          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          value={filters.rentOfTo || ""}
          onChange={(e) => setFilters({ ...filters, rentOfTo: e.target.value || undefined })}
        />
      </div>
    </div>

    <div className="mb-4">
      <label htmlFor="maxAmountReceivedFilter" className="block text-gray-700 text-sm font-bold mb-2">
        Max Amount Received
      </label>
      <input
        type="range"
        id="maxAmountReceivedFilter"
        min={0}
        max={300000}
        value={filters.maxAmountReceived || 0}
        className="cursor-pointer w-full bg-primary"
        onChange={(e) => setFilters({ ...filters, maxAmountReceived: parseInt(e.target.value) || undefined })}
      />
      <span className="text-sm text-gray-600">Value: {filters.maxAmountReceived || 'Any'}</span>
    </div>

    <div className="mb-4">
      <label htmlFor="maxBalanceAmountFilter" className="block text-gray-700 text-sm font-bold mb-2">
        Max Balance Amount
      </label>
      <input
        type="range"
        id="maxBalanceAmountFilter"
        min={0}
        max={300000}
        value={filters.maxBalanceAmount || 0}
        className="cursor-pointer w-full bg-primary"
        onChange={(e) => setFilters({ ...filters, maxBalanceAmount: parseInt(e.target.value) || undefined })}
      />
      <span className="text-sm text-gray-600">Value: {filters.maxBalanceAmount || 'Any'}</span>
    </div>

    <div className="mb-4">
      <label htmlFor="paymentCollectedByIdFilter" className="block text-gray-700 text-sm font-bold mb-2">
        Payment Collected By
      </label>
      <SuggestionInput
        setActiveValue={(value: string) => setFilters({ ...filters, paymentCollectedById: undefined })}
        activeValue={
          usersData?.content?.find((user: any) => user.userID === filters.paymentCollectedById)?.userName || ""
        }
        loading={usersLoading}
        setActiveIndex={(value: number) => {
          setFilters({ ...filters, paymentCollectedById: usersData?.content?.[value]?.userID });
        }}
        suggestions={usersData?.content?.map((user: any) => user.userName) || []}
      />
    </div>

    <div className="mt-6 flex flex-col sm:flex-row gap-2 sm:gap-4">
      <button
        className="w-full bg-primary hover:bg-secondary text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
        onClick={() => handleApplyFilters(filters)}
      >
        Apply Filters
      </button>
      <button
        className="w-full bg-red-400 hover:bg-red-500 text-white  font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
        onClick={handleClearFilters}
      >
        Clear Filters
      </button>
    </div>
      </>
        ) : (
          /* Expense Filters */
          <>
            <div className="mb-4">
              <label className="block text-gray-700 text-sm font-bold mb-2">Apartment</label>
              <select
                value={expenseFilters.apartmentId || ""}
                onChange={(e) => {
                  const apartmentId = Number(e.target.value) || undefined;
                  setExpenseFilters({ 
                    ...expenseFilters, 
                    apartmentId,
                    propertyId: undefined, 
                    tenantId: undefined 
                  });
                }}
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                disabled={isApartmentsLoading}
              >
                <option value="">Select Apartment</option>
                {apartments.map((apartment) => (
                  <option key={apartment.id} value={apartment.id}>
                    {apartment.apartmentName}
                  </option>
                ))}
              </select>
              {isApartmentsLoading && <p className="text-xs text-gray-500 mt-1">Loading apartments...</p>}
            </div>

                 <div className="mb-4">
              <label className="block text-gray-700 text-sm font-bold mb-2">Property</label>
              <select
                value={expenseFilters.propertyId || ""}
                onChange={(e) => {
                  const propertyId = Number(e.target.value) || undefined;
                  setExpenseFilters({ 
                    ...expenseFilters, 
                    propertyId,
                    tenantId: undefined // Reset tenant when property changes
                  });
                }}
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                disabled={isLoadingProperties}
              >
                <option value="">All Properties</option>
                {filteredProperties.map((property) => (
                  <option key={property.id} value={property.id}>
                    {property.propertyName}
                  </option>
                ))}
              </select>
              {isLoadingProperties && <p className="text-xs text-gray-500 mt-1">Loading properties...</p>}
            </div>

            <div className="mb-4">
              <label className="block text-gray-700 text-sm font-bold mb-2">Tenant</label>
              <select
                value={expenseFilters.tenantId || ""}
                onChange={(e) => setExpenseFilters({ 
                  ...expenseFilters, 
                  tenantId: Number(e.target.value) || undefined 
                })}
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                disabled={isLoadingTenants}
              >
                <option value="">All Tenants</option>
                {filteredTenants.map((tenant) => (
                  <option key={tenant.id} value={tenant.id}>
                    {tenant.name}
                  </option>
                ))}
              </select>
              {isLoadingTenants && <p className="text-xs text-gray-500 mt-1">Loading tenants...</p>}
            </div>

            <div className="mb-4">
              <label className="block text-gray-700 text-sm font-bold mb-2">Expense Type</label>
              <select
                value={expenseFilters.expenseType || ""}
                onChange={(e) => setExpenseFilters({ ...expenseFilters, expenseType: e.target.value || undefined })}
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              >
                <option value="">Select Type</option>
                <option value="PROPERTY_MANAGEMENT_FEES">Property Management Fees</option>
                <option value=" UTILITIES">Utilities</option>
                <option value="REPAIRS_AND_MAINTENANCE">Repairs & Maintenance</option>
                <option value="GARDEN_AND_LAWN_CARE">Garden and lawn care</option>
                <option value="CLEANING">Cleaning</option>
                 <option value="PEST_CONTROL">Pest Control</option>
                  <option value="PROPERTY_TAXES">Property Taxes</option>
                   <option value="SOCIETY_ASSOCIATION_FEES">Society/ Association Fees</option>
                    <option value="SECURITY_AND_MONITORING">Security & Monitoring</option>
                     <option value="LEASING_COSTS">Leasing Costs</option>
                   <option value="LEGAL_AND_PROFESSIONAL_FEES">Legal & Professional Fees</option>
                      <option value="HOUSEHOLD_SUPPLIES">Household Supplies</option>
              </select>
            </div>

           <div className="mb-4">
              <label htmlFor="maxExpenseAmountFilter" className="block text-gray-700 text-sm font-bold mb-2">
                Max Expense Amount
              </label>
              <input
                type="range"
                id="maxExpenseAmountFilter"
                min={0}
                max={30000}
                value={expenseFilters.amountTo || 0}
                className="cursor-pointer w-full bg-primary"
                onChange={(e) => setExpenseFilters({ ...expenseFilters, amountTo: parseInt(e.target.value) || undefined })}
              />
              <span className="text-sm text-gray-600">Value: {expenseFilters.amountTo || 'Any'}</span>
            </div>

            <div className="mb-4 flex flex-col sm:flex-row gap-4">
              <div className="w-full sm:w-1/2">
                <label className="block text-gray-700 text-sm font-bold mb-2">Date From</label>
                <input
                  type="date"
                  value={expenseFilters.dateFrom || ""}
                  onChange={(e) => setExpenseFilters({ ...expenseFilters, dateFrom: e.target.value || undefined })}
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                />
              </div>
              <div className="w-full sm:w-1/2">
                <label className="block text-gray-700 text-sm font-bold mb-2">Date To</label>
                <input
                  type="date"
                  value={expenseFilters.dateTo || ""}
                  onChange={(e) => setExpenseFilters({ ...expenseFilters, dateTo: e.target.value || undefined })}
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                />
              </div>
            </div>

            <div className="mt-6 flex flex-col sm:flex-row gap-2 sm:gap-4">
              <button
                className="w-full bg-primary hover:bg-secondary text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                onClick={() => handleApplyExpenseFilters(expenseFilters)}
                disabled={filterExpenses.isPending}
              >
                {filterExpenses.isPending ? "Applying..." : "Apply Filters"}
              </button>
              <button
                className="w-full bg-red-400 hover:bg-red-500 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                onClick={() => setExpenseFilters({})}
              >
                Clear Filters
              </button>
            </div>
          </>

        )}
      </div>

  {/* Right Side - Table */}
  <div className="w-full lg:w-3/4 p-2 sm:p-4">
    <header className="mb-4">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2">
        {/* <h1 className="text-xl sm:text-2xl font-bold">Reports</h1> */}
         <h1 className="text-xl sm:text-2xl font-bold">
              {viewType === "payment" ? "Payment Reports" : "Expense Reports"}
            </h1>
        <button
          className="bg-primary text-white flex gap-1 justify-center hover:bg-secondary rounded-lg px-4 py-2 text-sm"
          onClick={togglePopup}
        >
          Export
        </button>
      </div>
    </header>
    <div className="min-w-full overflow-x-auto">
       {viewType === "payment" ? (
      <Table
        columns={columns as any}
        loading={isPaymentHistoryLoading}
        data={paymentHistoryData?.data?.content || []}
      />
       ) : (
            /* Expense Table */
            <Table
              columns={expenseColumns as any}
              loading={isExpenseLoading}
               data={paginatedExpenseData?.data?.content || []}
            />
          )}
   {/* Display appropriate messages based on view type */}
          {viewType === "payment" ? (
            <>
      {isPaymentHistoryError && <p className="text-red-500 mt-2">Error loading payment history.</p>}
      {isPaymentHistoryLoading && <p className="text-gray-500 mt-2">Loading payment history...</p>}
      {!isPaymentHistoryLoading &&
        !isPaymentHistoryError &&
        (!paymentHistoryData?.data?.content || paymentHistoryData.data.content.length === 0) && (
        <div className="w-full h-20 flex justify-center items-center">
          <p className="text-gray-600 mt-2 flex items-center">
            No payment history available based on the filters.
          </p>
        </div>
      )}
        </>
          ) : (
          <>
              {isExpenseError && <p className="text-red-500 mt-2">Error loading expense history.</p>}
              {isExpenseLoading && <p className="text-gray-500 mt-2">Loading expense history...</p>}
              {!isExpenseLoading && 
                !isExpenseError && 
                (!paginatedExpenseData?.data?.content || paginatedExpenseData.data.content.length === 0) && (
                <div className="w-full h-20 flex justify-center items-center">
                  <p className="text-gray-600 mt-2 flex items-center">
                    No expense history available based on the filters.
                  </p>
                </div>
              )}
            </>
          )}


      {/* Pagination Controls */}
      {!isPaymentHistoryLoading && paymentHistoryData?.data?.content?.length > 0 && viewType === "payment" && (
        <div className="flex flex-col sm:flex-row justify-between items-center mt-4 gap-2">
        
          {/* Page size selection */}
          <div className="flex items-center space-x-2">
            <span className="text-gray-700 text-sm">Items per page:</span>
            <select
              value={itemsPerPage}
              onChange={handlePageSizeChange}
              className="border border-gray-300 rounded-md py-1 px-2 text-gray-700 focus:outline-none text-sm"
            >
              {pageSizeOptions.map((size) => (
                <option key={size} value={size}>
                  {size}
                </option>
              ))}
            </select>
          </div>

          {/* Pagination buttons */}
          <div className="flex items-center space-x-2">
               <div className="text-sm text-gray-600">
                Showing {paymentStartItem} to {paymentEndItem} of {paymentTotalItems} 
              </div>
            <button
              onClick={() => handlePageChange(1)}
              disabled={currentPage + 1 === 1}
              className="px-3 py-1 bg-gray-200 rounded-md hover:bg-gray-300 text-sm"
            >
              &lt;&lt;
            </button>
            <button
              onClick={handlePrevPage}
              disabled={currentPage + 1 === 1}
              className="px-3 py-1 bg-gray-200 rounded-md hover:bg-gray-300 text-sm"
            >
              &lt;
            </button>
            <span className="px-3 py-1 text-white bg-primary rounded-md text-sm">
              {currentPage + 1}
            </span>
            <button
              onClick={handleNextPage}
              disabled={currentPage + 1 === totalPages}
              className="px-3 py-1 bg-gray-200 rounded-md hover:bg-gray-300 text-sm"
            >
              &gt;
            </button>
            <button
              onClick={() => handlePageChange(totalPages)}
              disabled={currentPage + 1 === totalPages}
              className="px-3 py-1 bg-gray-200 rounded-md hover:bg-gray-300 text-sm"
            >
              &gt;&gt;
            </button>
          </div>
        </div>
      )}

            {/* Pagination Controls for Expense */}
          {!isExpenseLoading && paginatedExpenseData?.data?.content?.length > 0 && viewType === "expense" && (
            <div className="flex flex-col sm:flex-row justify-between items-center mt-4 gap-2">
            
            
                {/* Page size selection */}
                <div className="flex items-center space-x-2">
                  <span className="text-gray-700 text-sm">Items per page:</span>
                  <select
                    value={expenseItemsPerPage}
                    onChange={handleExpensePageSizeChange}
                    className="border border-gray-300 rounded-md py-1 px-2 text-gray-700 focus:outline-none text-sm"
                  >
                    {pageSizeOptions.map((size) => (
                      <option key={size} value={size}>
                        {size}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Pagination buttons */}
                <div className="flex items-center space-x-2">
                     {/* Item range display */}
              <div className="text-sm text-gray-600">
                Showing {expenseStartItem} to {expenseEndItem} of {expenseTotalItems} 
              </div>
                  <button
                    onClick={() => handleExpensePageChange(1)}
                    disabled={expenseCurrentPage + 1 === 1}
                    className="px-3 py-1 bg-gray-200 rounded-md hover:bg-gray-300 text-sm"
                  >
                    &lt;&lt;
                  </button>
                  <button
                    onClick={handleExpensePrevPage}
                    disabled={expenseCurrentPage + 1 === 1}
                    className="px-3 py-1 bg-gray-200 rounded-md hover:bg-gray-300 text-sm"
                  >
                    &lt;
                  </button>
                  <span className="px-3 py-1 text-white bg-primary rounded-md text-sm">
                    {expenseCurrentPage + 1}
                  </span>
                  <button
                    onClick={handleExpenseNextPage}
                    disabled={expenseCurrentPage + 1 === expenseTotalPages}
                    className="px-3 py-1 bg-gray-200 rounded-md hover:bg-gray-300 text-sm"
                  >
                    &gt;
                  </button>
                  <button
                    onClick={() => handleExpensePageChange(expenseTotalPages)}
                    disabled={expenseCurrentPage + 1 === expenseTotalPages}
                    className="px-3 py-1 bg-gray-200 rounded-md hover:bg-gray-300 text-sm"
                  >
                    &gt;&gt;
                  </button>
                </div>
              </div>
        
          )}
        </div>
      </div>

      {/* Export Popup */}
      {isPopupOpen && (
        <Popup onClose={togglePopup}>
          {viewType === "payment" ? (
            paymentHistoryData?.data?.content?.length > 0 ? (
              <ExportPopup
                data={paymentHistoryData.data.content}
                onClose={togglePopup}
                 filename={`${viewType}_report`}
              />
            ) : (
              <div style={{
                padding: '20px',
                background: '#f9f9f9',
                border: '1px solid #ccc',
                borderRadius: '5px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '15px',
              }}>
                <div style={{ fontWeight: 'bold', marginBottom: '10px' }}>No payment history available.</div>
                <button
                  onClick={togglePopup}
                  style={{
                    padding: '8px 15px',
                    background: '#09ba39',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer'
                  }}
                >
                  Close
                </button>
              </div>
            )
          ) : (
            paginatedExpenseData?.data?.content?.length > 0 ? (
              <ExportPopup
                data={paginatedExpenseData.data.content}
                onClose={togglePopup}
                 filename={`${viewType}_report`}
              />
            ) : (
              <div style={{
                padding: '20px',
                background: '#f9f9f9',
                border: '1px solid #ccc',
                borderRadius: '5px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '15px',
              }}>
                <div style={{ fontWeight: 'bold', marginBottom: '10px' }}>No expense history available.</div>
                <button
                  onClick={togglePopup}
                  style={{
                    padding: '8px 15px',
                    background: '#09ba39',
                    color: 'white',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer'
                  }}
                >
                  Close
                </button>
              </div>
            )
          )}
        </Popup>
      )}

      <AlertPopup
        alertPopup={alertPopup}
        setAlertPopup={setAlertPopup}
        errMessage={errmessage}
      />
    </div>
  );
};

export default PaymentHistory;
